import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Route } from '@app/core/route.service';
import { UploadDriversComponent } from './upload-drivers.component';

const routes: Routes = Route.withShell([
  { path: 'drivermanager', component: UploadDriversComponent, data: { title: 'Upload Drivers' } }
]);

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports:[RouterModule],
  declarations: []
})
export class UploadDriversRoutingModule { }
